import { useState } from 'react'
import { Eye, EyeOff, Lock } from 'lucide-react'
import type { InputProps } from '@/components/ui'
import { Input } from '@/components/ui'

/** Password input with a show/hide toggle and a lock icon. */
export default function PasswordField(
  props: Omit<InputProps, 'type' | 'iconLeft' | 'rightSlot'>,
) {
  const [show, setShow] = useState(false)
  return (
    <Input
      {...props}
      type={show ? 'text' : 'password'}
      iconLeft={<Lock size={18} />}
      rightSlot={
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          aria-label={show ? 'Masquer' : 'Afficher'}
          style={{
            position: 'absolute',
            right: 12,
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--ink-3)',
            padding: 4,
            display: 'inline-flex',
          }}
        >
          {show ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      }
    />
  )
}
